<template>
  <frame-auth width="400">
    <common-form @submit="login">
      <v-card-text>
        <p class="grey--text text-center">
          Please use your doctor credentials below to log in
        </p>

        <v-text-field
          id="login_username"
          v-model="credential.username"
          :rules="[$validators.isValid()]"
          prepend-icon="mdi-account"
          placeholder="Username"
          solo
          flat
          outlined
          dense
        />

        <v-text-field
          id="login_password"
          v-model="credential.password"
          :rules="[$validators.isValid()]"
          type="password"
          prepend-icon="mdi-key-variant"
          placeholder="Password"
          solo
          flat
          outlined
          dense
        />
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />

        <v-btn
          class="pa-4"
          color="primary"
          rounded
          type="submit"
        >
          Login
        </v-btn>
      </v-card-actions>
    </common-form>
  </frame-auth>
</template>

<script>
import { reactive } from '@vue/composition-api'
import { auth, AuthConfig } from 'ui-common'

export default {
  name: 'Login',
  layout: 'auth',
  setup: () => {
    const credential = reactive({
      username: '',
      password: ''
    })

    const login = () => {
      auth.login(credential)
    }

    return {
      credential,
      login
    }
  }
}
</script>
